import { getOr } from 'lodash/fp';

const choices = {
    yes: { point: [2] },
    no: { point: [2] },
};
const question = (point, investorProfile) => ('no' === investorProfile.lifeInsuranceLosses ? {} : getOr(null, point, choices));

export default question;
